import { useMapValue } from "@/components/MapContainer/context"
import { SHOW_SINGLE_STORE_ZOOM } from "@/constants/constant"
import { useConfigModel, useControllerModel, useSelectionModel, useStoreListModel } from "@/models"
import { getBranchThemeColors } from "@/util/commonUtils"
import { useCreation } from "ahooks-v2"
import { Checkbox } from "antd"
import classNames from "classnames"
import type { FC } from "react"
import { useCallback } from "react"
import { isNH } from "@/constants/NHConfig"
import "./index.scss"
// ==============================================
import ColorScale from "@/components/ColorScale"
// ==============================================
interface BrandPanelProps {
  brandName?: string
  zoom?: number
  legendColors?: string[]
  visible?: boolean
}
const BrandPanel: FC<BrandPanelProps> = ({
  brandName = "",
  zoom = 3,
  legendColors,
  visible = true,
}) => {
  const { toggleBranchShow, getBranchShow } = useMapValue()
  const allBranchShow = getBranchShow()
  const { unlockedShow, lockedShow, selectionShow } = allBranchShow
  const { lockedCount, unlockedCount } = useStoreListModel()
  const { sitePointList } = useSelectionModel()
  const { industryCategory } = useConfigModel()
  const { theme } = useControllerModel()

  // 总数
  const total = useCreation(() => {
    return lockedCount + unlockedCount
  }, [lockedCount, unlockedCount])

  // 获取网点主题颜色
  const colorTheme = useCreation(() => {
    return getBranchThemeColors()
    // eslint-disable-next-line
  }, [theme])

  // 控制网点显隐
  const toggleShowFn = useCallback(
    (type: string, isShow: boolean) => {
      const params = {
        ...allBranchShow,
        [type]: isShow,
      }
      // 控制已开通/未开通网点的显隐
      toggleBranchShow && toggleBranchShow(params)
    },
    [allBranchShow, toggleBranchShow],
  )

  const content = useCreation(() => {
    return (
      <div className="data-panel">
        <div className="brand-name">
          {brandName} ({total})
        </div>
        <p
          className={classNames({
            closed: !unlockedShow,
          })}
          onClick={() => toggleShowFn("unlockedShow", !unlockedShow)}
        >
          <Checkbox className="theme-checkbox-highlight" checked={unlockedShow} />
          &nbsp;&nbsp;{isNH ? "已授权网点" : `已开通${industryCategory}`} ({unlockedCount})
        </p>
        <p
          className={classNames({
            closed: !lockedShow,
          })}
          onClick={() => toggleShowFn("lockedShow", !lockedShow)}
        >
          <Checkbox className="theme-checkbox-highlight" checked={lockedShow} />
          &nbsp;&nbsp;{isNH ? "未授权网点" : `未开通${industryCategory}`} ({lockedCount})
        </p>
      </div>
    )
  }, [
    colorTheme,
    lockedCount,
    unlockedCount,
    total,
    sitePointList,
    unlockedShow,
    lockedShow,
    selectionShow,
    toggleShowFn,
    industryCategory,
    brandName,
  ])

  const totalContent = useCreation(() => {
    return (
      <>
        <div className="brand-name">
          {brandName} ({total})
        </div>
        <ColorScale legendColors={legendColors} />
      </>
    )
  }, [brandName, total, legendColors])

  return visible ? (
    <div className="brand-panel">{zoom >= SHOW_SINGLE_STORE_ZOOM ? content : totalContent}</div>
  ) : null
}

export default BrandPanel
